import React from 'react';
import { isDeleteDisabled, isCancelExportDisabled, isExportDisabled } from '../../../../services';
import { ActionMenu } from '../../../../components';
import { ICONS } from '../../../../interfaces';
import { useListAppPermissions } from '../../../../hooks';
export var EditListMenu = function (_a) {
    var conditions = _a.conditions, buttonHandlers = _a.buttonHandlers;
    var permissions = useListAppPermissions();
    var isExportInProgress = conditions.isExportInProgress;
    var actionButtons = [];
    var initExportButton = {
        label: 'export-all',
        icon: ICONS.download,
        onClick: buttonHandlers['export-all'],
        disabled: isExportDisabled(conditions)
    };
    var initExportAllButton = {
        label: 'export-visible',
        icon: ICONS.download,
        onClick: buttonHandlers['export-visible'],
        disabled: isExportDisabled(conditions)
    };
    var cancelExportButton = {
        label: 'cancel-export',
        icon: ICONS.download,
        onClick: buttonHandlers['cancel-export'],
        disabled: isCancelExportDisabled(conditions)
    };
    var exportSlot = isExportInProgress ? [cancelExportButton] : [initExportButton, initExportAllButton];
    var deleteSlot = {
        label: 'delete',
        icon: ICONS.trash,
        onClick: buttonHandlers.delete,
        disabled: isDeleteDisabled(conditions)
    };
    if (permissions.canExport) {
        actionButtons.push.apply(actionButtons, exportSlot);
    }
    if (permissions.canDelete) {
        actionButtons.push(deleteSlot);
    }
    return actionButtons.length ? React.createElement(ActionMenu, { actionButtons: actionButtons }) : React.createElement(React.Fragment, null);
};
